<template>
  <el-container :class="['report-component-container', referenceObjParam && referenceObjParam.type === 'rc-report' && 'rc-report-width', report && parseInt(report.reportType) === 5 && 'report-component-custom-page']" ref="reportComponentList" :style="getBackground">
      <template v-if="report && parseInt(report.reportType) !== 5 && parseInt(report.reportType) !== 7">
        <el-main v-show="page.visible">
          <div :class="['report-container', getSpliceChildren.length && !hasChildren && 'has-children', getMoreTypeFilter.length && 'display-report-container']">
        <!-- 开启了更多模式的下拉选项 -->
        <div class="report-filter-more-type" v-if="getMoreTypeFilter.length > 0">
          <report-filter-more-type :report="report" @search="searchFilterWitchMoreType" :reportFilters="report.filters.filter(m => m.filterType !== 'senior' && m.moreType)"></report-filter-more-type>
        </div>
        <div class="report-content">
          <!-- 头部按钮与筛选框,条件渲染-->
          <el-row v-if="renderReportFilter">
            <el-col class="report-component-filters"  :style="{'width':getFilterWidth}">
              <div class="grid-content bg-purple">
                <report-filter
                  ref="filter"
                  :componentWidth="componentWidth"
                  :reportFilters="report.filters.filter(m => m.filterType !== 'senior' && !m.moreType)"
                  :reportId="report.id"
                  :report="report"
                  :getButtonLength="getButtons.length"
                  :buttonsLength="getButtonsLength"
                  :initFilterState="initFilterState"
                  @reset="reset"
                  @search="searchFilter"
                  @openSeniorFilter="openSeniorFilter"
                  @closeOrOpen="closeOrOpen"/>
              </div>
            </el-col>
            <el-col class="row-right" :style="{'width':getButtons.length>0?getButtonsLength:'0'}">
              <div class="buttons" id="buttons">
                <!-- 只有一个按钮的情况-->
                <el-button class="first-button" v-if="getButtons.length === 1" :disabled="isDisabled(getButtons[0])" type="text"  @click="doAction(getButtons[0], report.id, report.mainTableId,report.name,currentRowData)" :title="getButtons[0].name"> {{getButtons[0].name}}</el-button>
                <!-- 多个按钮的情况-->
                <template  v-if="getButtons.length>1">
                  <!--展开按钮-->
                  <el-button v-for="item in getOpenButtons" :key="item.id" class="open-button" :disabled="isDisabled(item)" type="text"  @click="doAction(item, report.id, report.mainTableId,report.name,currentRowData)" :title="item.name"> {{item.name}}</el-button>
                  <!--折叠按钮-->
                  <el-dropdown class="create-dropdown" @command="handleCommand" v-if="getFoldButtons.length>1" size="mini" split-button trigger="click">
                    <el-button :disabled="isDisabled(getFoldButtons[0])"  @click="doAction(getFoldButtons[0], report.id,report.mainTableId,report.name,currentRowData)" type="text"  :title="getFoldButtons[0].name"> {{getFoldButtons[0].name}}</el-button>
                    <el-dropdown-menu class="filterMenu" slot="dropdown">
                      <template v-for="button in getFoldButtons.filter((n,index) => index>0)">
                        <el-dropdown-item :disabled="isDisabled(button)" :key="button.id" :command="{'type':'withoutImportButon','button':button,'dataId':report.id, 'reportId':report.mainTableId,'name':report.name}">{{button.name}}</el-dropdown-item>
                      </template>
                    </el-dropdown-menu>
                  </el-dropdown>
                  <el-button v-if="getFoldButtons.length===1" class="open-button" :disabled="isDisabled(getFoldButtons[0])" type="text" @click="doAction(getFoldButtons[0], report.id,report.mainTableId,report.name,currentRowData)" :title="getFoldButtons[0].name"> {{getFoldButtons[0].name}}</el-button>
                </template>
              </div>
            </el-col>
          </el-row>
          <div>
            <senior-filter ref="seniorFilter" :logicPanelData="logicPanelData" @expression="expression"></senior-filter>
          </div>

          <table-paganition
            v-if="parseInt(report.reportType) <= 1"
            ref="tablePaganition"
            :data="data"
            :count="page.count"
            :report="report"
            :filtersData='filtersData'
            :formRuntimeDialog="formRuntimeDialog"
            @search="search"
            @page="searchPage"
            @current-change='currentChange'
            @row-dbclick="rowDbClick"
            @row-click="rowClick"
            @cell-click="cellClick"
            :loading="page.loading"
            :summaryData="summaryData"
            :hasChildren="hasChildren"
            :hasSummary='hasSummary'
            :formDefinition="formDefinition"
            :referenceObjParam="referenceObjParam"
            :isExpand="isExpand"
            :renderReportFilter="renderReportFilter"
            :noPagination="noPagination">
          </table-paganition>
          <div v-else class="graph-report-runtime">
            <template v-if="parseInt(report.reportType) === 2">
              <histogram-report ref="histogramReportDesign" v-if="data.length > 0 && report.norm" :graphData="data" :norm="report.norm.norm" :dimensionality="report.dimensionality"></histogram-report>
            </template>
            <template v-if="parseInt(report.reportType) === 3">
              <pie-report ref="pieReportDesign" v-if="data.length > 0 &&report.norm" :graphData="data" :norm="report.norm.norm" :dimensionality="report.dimensionality"></pie-report>
            </template>
            <template v-if="parseInt(report.reportType) === 4">
              <line-report ref="lieReportDesign" v-if="data.length > 0 && report.norm" :graphData="data" :norm="report.norm.norm" :dimensionality="report.dimensionality"></line-report>
            </template>
          </div>
        </div>
      </div>

      <children-splice v-if="getSpliceChildren.length && !hasChildren" :children='getSpliceChildren' :current-row='currentRow' :formRuntimeDialog="formRuntimeDialog" ref="spliceChildren"/>

      <children-dialog v-if="getDialogChildren.length && !hasChildren" :children='getDialogChildren' :current-row='currentRow' :formRuntimeDialog="formRuntimeDialog" :visible="page.childrenDialogVisiable" @close='closeChildrenDialog'/>

    </el-main>
        <el-dialog class="runtime-dialog" :visible.sync="page.dialog.visible" :title="page.dialog.title" :width="page.dialog.width"
               center append-to-body :close-on-click-modal="false" @closed="closeRuntimeDialog">
        <div class="safety-password-dialog" v-if="page.dialog.view === 'setSecurityPassword'">
          <div class="hint">使用此功能需要输入安全密码</div>
          <el-form ref="safetyPasswordForm" :inline="true" @submit.native.prevent="checkSecurityPassword" :hide-required-asterisk="true">
            <el-form-item label="安全密码" :error="errorMessage">
              <el-input ref="safetyInput" v-model="security.password" auto-complete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="safety-password-dialog-footer">
            <el-button type="primary" @click="checkSecurityPassword">确定</el-button>
            <el-button @click="goBack">取消</el-button>
          </div>
        </div>
        <template v-if="page.dialog.view === 'importError'">
          <p class="center red">导入失败</p>
          <p class="center">导入失败，文件超过 5MB，请联系管理员。</p>
        </template>
        <template v-if="page.dialog.view === 'exportError'">
          <p class="center red">导出失败</p>
          <p class="center">导出失败，数据集超过 1.5万条记录，请联系管理员。</p>
        </template>
        <template v-if="page.dialog.view === 'import' || page.dialog.view === 'import-action'">
          <div class="runtime-dialog-file">
            <div class="runtime-dialog-file-title">请先下载模板，然后按格式导入<el-button @click.stop="downDataTemplate(report.mainTableId,report.id,report.name)" type="primary">下载模板</el-button>
              <el-tooltip effect="dark" content="模板中的第二行为示例数据，请修改后再导入。" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <div class="runtime-dialog-file-upload">
              <!--handleClearFiles事件不生效,记得处理 -->
              <el-upload
                action=""
                ref="uploadButton"
                class="el-upload"
                :http-request="upDataTemplate"
                :data="report"
                accept=".xls,.xlsx"
                :limit="1"
                :before-upload="beforeUpload"
                :on-success="afterUpload"
                :on-error="afterUpload"
                :show-file-list="false">
                <el-button type="primary" @click="handleClearFiles">上传文件</el-button>
              </el-upload>
              <el-tooltip effect="dark" content="仅支持xls,xlsx" placement="right">
                <i class="el-icon-info"></i>
              </el-tooltip>
            </div>
            <!-- 文件图标框-->
            <div :class="['runtime-dialog-file-rectangle',(page.fileStatus === 'uploadFail' || page.fileStatus === 'importFail' || page.fileStatus === 'afterImport')&& 'runtime-dialog-file-rectangle-fail', (page.fileStatus === 'uploadSuccess' || page.fileStatus === 'importSuccess' || page.fileStatus === 'isImporting') && 'runtime-dialog-file-rectangle-success']"></div>
            <el-progress :percentage="page.fileProgress" :style="{visibility:page.fileProgress !==0 ? 'visible':'hidden'}" :stroke-width="4" :show-text="false"></el-progress>
            <!-- 文件名，导入失败结果展示-->
            <p class="fileStatusName" :style="{visibility: page.fileStatus && (page.fileStatus !== 'isUploading' || page.fileStatus === 'afterImport')?'visible':'hidden'}">
              <span v-if="page.fileStatus !== 'importFail'">{{page.fileName}}&emsp;<i class="el-icon-success" v-show="page.fileStatus === 'uploadSuccess' || page.fileStatus === 'importSuccess'"></i></span>
            </p>
            <div class="runtime-dialog-file-name">文件将被导入至: <span>{{report.name}}</span></div>
            <!-- 上传结果，导入结果展示-->
            <p :class="['runtime-dialog-file-status',{'file-status-visible':page.fileStatus && page.fileStatus !== 'isUploading' && page.fileStatus !== 'isImporting','file-status-color':page.fileStatus === 'uploadFail' || page.fileStatus === 'importFail' || page.fileStatus === 'afterImport'}]">
              <span v-if="!page.fileStatus.includes('Import') && !page.fileStatus.includes('import')">{{page.fileStatus === 'uploadSuccess'?'上传成功!':'上传失败'}}</span>
              <span v-else-if="page.fileStatus === 'afterImport'">导入失败</span>
              <span v-else-if="page.fileStatus === 'importSuccess'">导入成功!</span>
              <span v-else-if="page.fileStatus !== 'isImporting'&&page.fileStatus !== 'importSuccess'">已导入成功{{page.uploadResult.successDataCount}}条，失败{{page.uploadResult.errorDataCount}}条<i class="el-icon-download" @click="downErrorDataTemplate">下载失败列表</i></span>
            </p>
            <!-- 导入进度条 -->
            <span v-show="page.fileStatus === 'isImporting'">正在导入，请稍等...</span>
            <el-progress class="import-file-progress" :percentage="page.importFileProgress" v-show="page.fileStatus === 'isImporting'" :stroke-width="8" :show-text="false"></el-progress>
            <!-- 对比字段 -->
            <div class="compareWord" v-if="importType!=='increase'">
              <span>比对字段</span>
              <el-tooltip effect="dark" content="比对字段存在则更新，不存在则新增，比对字段应该为唯一不重复的值，否则将会有更新错误风险" placement="bottom">
                <i class="el-icon-info"></i>
              </el-tooltip>
              <el-select v-model="compareField" placeholder="请选择" clearable>
                <el-option v-for="item in report.columns" :key="item.id" :label="item.name" :value="item.expressionText.split('+')[0].split('{')[1]"></el-option>
              </el-select>
            </div>
            <el-button v-if="page.uploadResult.showButton" type="primary" @click="importDataTemplate" :loading="page.fileStatus === 'isImporting'">立即导入</el-button>
            <el-button class="cancal-button" @click="page.dialog.visible = false">取 消</el-button>
          </div>
        </template>
      </el-dialog>
      </template>
      <template v-if="report && parseInt(report.reportType) === 5">
          <custom-page-runtime :reportId="report.id" :choiceControls="customPageParams.controls" :pageSize="customPageParams.pageSize" :background="report.background"></custom-page-runtime>
      </template>
      <template v-if="report && parseInt(report.reportType) === 7">
        <billboard-runtime v-on="$listeners" :billboardProperties=report.kanBanProperties :report=report :id=report.id></billboard-runtime>
      </template>
  </el-container>
</template>

<script>
import '@/assets/scss/common.scss'
import _ from 'lodash'
import ReportFilter from './report-filter.vue'
import TablePaganition from './table-pagination.vue'
import ChildrenSplice from './children-splice.vue'
import ChildrenDialog from './children-dialog.vue'
import {buttonMixin} from './button.js'
import SeniorFilter from '../design/senior-logic-panel'
import HistogramReport from '../../public/graphReport/histogram-report'
import lineReport from '../../public/graphReport/line-report'
import pieReport from '../../public/graphReport/pie-report'
import customPageRuntime from './custom-page-runtime'
import billboardRuntime from './billboard-runtime'
import reportFilterMoreType from './report-filter-more-type'
import Controls from '../design/customPage/assets/js/controls'
import moment from 'moment'
import CookieOperation from '@/plugins/cookie'
export default {
  name: 'report-component',
  inject: ['eventBus', 'redcatApp'],
  mixins: [buttonMixin],
  components: {
    ReportFilter,
    TablePaganition,
    ChildrenSplice,
    ChildrenDialog,
    SeniorFilter,
    HistogramReport,
    lineReport,
    pieReport,
    customPageRuntime,
    reportFilterMoreType,
    billboardRuntime
  },
  props: ['report', 'external-filters', 'formRuntimeDialog', 'hasChildren', 'formDefinition', 'isExpand', 'referenceObjParam'],
  data () {
    return {
      importType: 'increase',
      compareField: '',
      filtersData: {}, // 筛选项
      logicPanelData: {
        filters: [],
        table: {},
        dialogVisible: false,
        expression: ''
      },
      page: {
        visible: true,
        count: 0,
        loading: false,
        dialog: {},
        childrenDialogVisiable: false,
        uploadResult: {
          successDataCount: 0,
          errorDataCount: 0,
          dataCount: 0,
          totalCount: 0,
          modificationTime: '',
          showButton: true
        },
        fileName: '',
        fileStatus: '',
        fileProgress: 0,
        errorDataUrl: '',
        fileDir: '',
        exportFileProgress: 0, // 导出文件进度
        importFileProgress: 0, // 导入文件进度
        isimportSuccess: 0 // 导入是否成功
      },
      currentRow: '',
      currentRowData: {},
      data: [],
      param: {},
      security: {password: '', tipShow: false},
      errorMessage: '',
      summaryData: {},
      hasSummary: false,
      file: '',
      openStartLoadData: this.report.openStartLoadData,
      customPageParams: {
        controls: [],
        pageSize: {}
      },
      componentWidth: 0,
      initFilterState: true,
      clearTimer: 0
    }
  },
  async created () {
    if (parseInt(this.report.reportType) !== 5) {
      // 将字段重新进行排序
      this.report.columns = _.sortBy(this.report.columns, m => m.sort)
      this.report.columns.forEach(m => {
        if (m.format != null) {
          m.format.colorFormats = JSON.parse(m.format.colorFormats)
          m.format.displayFormats = JSON.parse(m.format.displayFormats)
          m.format.dataFormat = JSON.parse(m.format.dataFormat)
        } else {
          m.format = {
            colorFormats: [],
            displayFormats: [],
            dataFormat: {}
          }
        }
      })
      try {
        if (!this.hasChildren) {
          await this.handlerFilter().then(() => this.isSecurityEnable())
        }
      } finally {
        this.$nextTick(() => { this.initFilterState = false })
      }
      // 子组件没创建好数据渲染,所以监听不到
      if (this.externalFilters) {
        this.getAllexternalFilters = this.externalFilters
        // 当外部条件改变时, 重新加载报表
        this.initParam()
      }
      this.eventBus.$on('report.search', this.search)
    } else {
      let data = this.report
      //  pageSize转json.兼容历史数据没pageSize
      if (data.pageSize) {
        data.pageSize = JSON.parse(data.pageSize)
      } else {
        data.pageSize = {'width': 1, 'height': 1}
      }
      data.controls = this.disposeHistoryData(JSON.parse(data.controls))
      this.$set(this, 'customPageParams', data)
    }
  },
  watch: {
    'externalFilters' (externalFilter) {
      // 将子主表的字段拼成筛选条件
      this.getAllexternalFilters = externalFilter
      // 当外部条件改变时, 重新加载报表
      // 子表当前页显示条数
      let pageSize = this.$refs.tablePaganition ? this.$refs.tablePaganition.pagination.pageSize : 0
      this.initParam(pageSize)
    }
  },
  methods: {
    handlerFilter () {
      let promises = []
      this.report.filters.forEach(m => {
        promises.push(new Promise(async (resolve, reject) => {
          if (m.dataType && m.dataType.includes('date')) {
            await this.$axios.post('/form-api/runtime/calc', {'formula': m.defaultValue})
              .then(res => {
                m.defaultValue = res.data
                // 日期时间类型的话没有时间默认是0点
                if (res.data && m.dataType === 'datetime' && !moment(res.data, 'YYYY-MM-DD HH:mm:ss', true).isValid()) {
                  m.defaultValue = `${res.data} 00:00:00`
                }
                resolve()
              }).catch(e => reject(e))
          } else {
            resolve()
          }
        }))
      })
      return Promise.all(promises)
    },
    goSearch (title) {
      // if (title !== '查看') {
      //   this.param.index = 1
      //   this.$refs.tablePaganition.pagination.currentPage = 1
      // }
      this.search()
    },
    popUpSearch () {
      this.search()
    },
    init () {
      this.$refs.filter && this.$refs.filter.init()
      // 请求报表数据
      this.initParam()
    },
    closeChildrenDialog () {
      this.page.childrenDialogVisiable = false
    },
    currentChange (row) {
      this.currentRow = row
    },
    rowDbClick () {
      this.page.childrenDialogVisiable = true
    },
    rowClick (row) {
      this.currentRowData = row
    },
    cellClick (param) {
      this.$emit('cell-click', param)
    },
    goBack () {
      this.closeDialog()
      this.$emit('closeReportDialog')
    },
    isSetSecurityPassword () {
      // 是否使用设置安全密码
      return new Promise((resolve, reject) => {
        let id = sessionStorage.getItem('userId')
        this.$axios.get(`/auth-api/security/${id}`)
          .then(res => {
            // 使用设置了安全密码
            resolve(res.data)
          })
      })
    },
    // 验证输入安全密码的期限
    isSetSecurityPasswordEffective () {
      return new Promise((resolve, reject) => {
        let id = sessionStorage.getItem('userId')
        this.$axios.get(`/auth-api/security/isReportPasswordEffective/${id}`)
          .then(res => {
            // 使用设置了安全密码
            resolve(res.data)
          })
      })
    },
    // 出现是否去设置安全密码的弹窗
    isSetSecurityPasswordDialog () {
      this.$confirm('查看该报表需要输入安全密码</br>由于您暂未设置“安全密码”，请前往设置', '安全验证', {
        confirmButtonText: '立即设置',
        cancelButtonText: '暂不设置',
        customClass: 'publishMessageBox',
        center: true,
        dangerouslyUseHTMLString: true
      }).then(() => {
        this.$router.push({name: 'settingSecurityPassword'})
      }).catch(() => this.$router.go(-1))
    },
    enterPassword () {
      this.openDialog('setSecurityPassword', '提示', '392px', '')
    },
    checkSecurityPassword () {
      if (!this.security.password) {
        this.errorMessage = '安全密码不可为空'
        this.$refs.safetyInput.focus()
        return false
      }
      let id = sessionStorage.getItem('userId')
      // 调接口验证安全密码
      this.$axios.get(`/auth-api/security/validator?id=${id}&password=${this.security.password}`).then(res => {
        // 使用设置了安全密码
        if (res.data) {
          this.closeDialog()
          this.page.visible = true
          this.init()
        } else {
          this.errorMessage = '请输入正确的安全密码'
          this.$refs.safetyInput.focus()
        }
      })
    },
    isSecurityEnable () {
      // 从developer调整过来的接口不需要进过安全校验
      let isTest = CookieOperation.get('isTest')
      if (!isTest && this.report.securityEnable) {
        this.page.visible = false
        this.isSetSecurityPassword()
          .then((res) => {
            if (res) {
              this.isSetSecurityPasswordEffective()
                .then((res) => {
                  if (res) {
                    // 安全密码没过期
                    this.page.visible = true
                    this.init()
                  } else {
                    // 安全密码过期,重新出现安全密码设置页面
                    this.enterPassword()
                  }
                })
            } else {
              this.isSetSecurityPasswordDialog()
            }
          })
      } else {
        this.init()
      }
    },
    initParam (pageSize = 0) {
      this.param.index = 1
      // 以 -999 分页大小作为 不分页 的标志
      this.param.size = Number(this.report.pageNumber) === -999 ? 20 : Number(this.report.pageNumber)
      if (this.report.children && this.hasChildren) {
        // 子表修改过当前页显示条数则使用pageSize否则100
        this.param.size = pageSize || 100
        // 重新加载子表数据时都从第一页开始
        this.$refs.tablePaganition && (this.$refs.tablePaganition.pagination.currentPage = 1)
      }
      let condition = {}
      this.report.filters.forEach(m => {
        if (m.filterType && m.filterType !== 'senior') {
          condition[m.id] = m.defaultValue
        }
      })
      // 将子表的筛选条件带进去
      this.getAllexternalFilters && this.getAllexternalFilters.forEach(m => {
        _.defaults(condition, m)
      })

      this.searchFilter(condition, true)
    },
    reset () {
      this.param.index = 1
      this.param.sort = '' // 排序清空
      this.$refs.tablePaganition.clearSort() // 清除排序样式
      this.$refs.tablePaganition.pagination.currentPage = 1
      let condition = {}
      this.report.filters.forEach(m => {
        condition[m.id] = m.defaultValue
      })
      // 重置高级筛选
      this.$refs.seniorFilter && this.$refs.seniorFilter.resetFilters()
      delete this.param.filters.seniorFilter
      this.$nextTick(() => {
        this.searchFilter(condition)
      })
    },
    searchFilter (condition, isFirst = false) {
      let cloneCondition = _.cloneDeep(condition)
      for (let key in cloneCondition) {
        // 多选处理
        if (cloneCondition[key] instanceof Array) {
          cloneCondition[key] = condition[key].join(', ')
        }
      }
      // 为了使得勾选/树状模式勾选的数据不被覆盖
      this.param.filters = _.merge(this.param.filters, cloneCondition)
      // 第一次进来如果 打开时不加载数据 开关打开 则不走查询接口，否则判断筛选项是否全部填写
      if (isFirst) {
        if (!this.openStartLoadData) {
          this.search()
        }
      } else {
        // 判断开启了勾选/树状模式的下拉框是否填写数据
        let requiredFilters = this.report.filters.filter(f => f.moreType && f.required)
        let noSelect = requiredFilters.filter(f => !this.param.filters[f.id])
        if (noSelect && noSelect.length) {
          return this.$message.error(`${noSelect.map(m => m.name).join(', ')}必填`)
        }
        let canSearch = true
        if (this.openStartLoadData) {
          let keys = Object.keys(this.param.filters)
          if (keys && keys.length) {
            for (let i = 0; i < keys.length; i++) {
              // 必须所有选项都填写了
              if (!this.param.filters[keys[i]]) {
                canSearch = false
              }
            }
          } else {
            canSearch = false
          }
        }
        canSearch ? this.search() : this.$message({
          message: '筛选项必须填写！',
          type: 'error',
          center: true,
          customClass: 'filter-error-class'
        })
      }
      // 传给table筛选项的值
      this.filtersData = cloneCondition
    },
    searchPage (page) {
      this.param.index = page.currentPage
      this.param.size = page.pageSize
      this.param.sort = page.sort
      this.search()
    },
    async search () {
      let index = -1
      let currentRow = this.$_.cloneDeep(this.currentRow)
      if (this.judgeChildren() && currentRow) {
        index = this.data.findIndex(d => d.Id === currentRow.Id)
      }
      let params = this.param
      // 如果是被rc-report 所引用, 则参数使用用户设计的
      if (this.referenceObjParam && this.referenceObjParam.type === 'rc-report') {
        this.referenceObjParam.params.index = params.index
        params = this.referenceObjParam.params
      }
      // 如果是风琴报表，则需要查询全部，不分页
      params.index = this.isExpand ? -1 : params.index
      this.page.loading = true
      try {
        await this.eventBus.$emit('report.onSearch', this)
      } catch (e) {
        console.log(e)
        return null
      }

      if (this.$refs && this.$refs.tablePaganition) {
        this.$refs.tablePaganition.expands = []
      }
      this.$axios.get(`/report-api/report/data/${this.report.id}/count`, {params})
        .then(res => {
          // 是辅助表有最大记录条数
          if (this.report.dataSourceReport) {
            this.page.count = this.report.maxTotal && res.data > this.report.maxTotal ? this.report.maxTotal : res.data
          } else {
            this.page.count = res.data
          }
          if (this.page.count > 0 && (params.index - 1) * params.size >= this.page.count) {
            this.$refs.tablePaganition.pagination.currentPage--
          }
          if (Number(this.report.pageNumber) === -999 && !(this.referenceObjParam && this.referenceObjParam.type)) {
            if (this.page.count <= 500) {
              params.index = -1
            } else {
              params.index = 1
            }
          }
          if (parseInt(this.report.reportType) !== '7') {
            //  如果为看板则在runtime单独走接口，因为要重复查询。逻辑不一样
            this.$axios.get(`/report-api/report/data/${this.report.id}`, {params})
              .then(async res => {
                this.handleReportData(res, params, index, currentRow)
              })
          }
          this.eventBus.$emit('report.onCountLoad', { data: this, reportId: this.report.id, params: params })
        })
      this.getSummary()
    },

    // 处理报表数据
    async handleReportData (res, params, index, currentRow) {
      // 是辅助表有最大记录条数
      let flag = /(^[1-9]\d*$)/.test(this.report.maxTotal / params.size) ? Math.ceil(this.report.maxTotal / params.size) + 1 === params.index : Math.ceil(this.report.maxTotal / params.size) === params.index
      if (this.report.dataSourceReport && this.report.maxTotal && flag) {
        res.data = res.data.slice(0, this.report.maxTotal % params.size)
      }
      // 为了处理批量处理的问题
      res.data.forEach(m => {
        m.checked = false
      })
      // 如果开启了列编辑，处理返回的列数据，如果列的值为空，不会返回列id，需要手动加上
      if (this.report.columnEdit) {
        let columns = this.report.columns.filter(c => JSON.parse(this.report.editColumns).find(m => m.id === c.id || m.combobxColumnId === c.id)).map(m => m.id)
        if (columns.length && res.data.length !== columns.length) {
          res.data.forEach(c => {
            columns.forEach(m => m && !c.hasOwnProperty(m) && this.$set(c, m, ''))
          })
        }
      }
      this.data = this.isExpand ? res.data.slice(0, 1000) : res.data
      // 新增_uuid作为独特的标识用于表格渲染
      this.data.forEach(item => {
        if (!item.hasOwnProperty('_uuid')) {
          item['_uuid'] = this.$UUID.create()
        }
      })
      await this.eventBus.$emit('report.onDataLoad', {data: this.data, reportId: this.report.id, params: params})
      this.$nextTick(() => {
        this.eventBus.$emit('report.loadSucceed')
        if (this.judgeChildren()) {
          // 如果查询前选中的数据被删除了
          if (!this.data.find(c => c.Id === currentRow.Id) && index !== -1) {
            // 重新选中
            if (this.data[index]) {
              currentRow = this.data[index]
            } else {
              // 否则取删除前索引的上一条数据，如果没有则空
              currentRow = this.data[index - 1] || ''
            }
          }
          // 如果查询之前有选中数据，则使用选中数据，如果没有，则默认第一条数据
          this.$refs.tablePaganition && this.$refs.tablePaganition.rowClick(currentRow || this.data[0])
        } else {
          this.$refs.tablePaganition && this.$refs.tablePaganition.rowClick({})
        }
        if (parseInt(this.report.reportType) === 2) {
          this.$refs.histogramReportDesign && this.$refs.histogramReportDesign.drawLine()
        } else if (parseInt(this.report.reportType) === 3) {
          this.$refs.pieReportDesign && this.$refs.pieReportDesign.drawLine()
        } else if (parseInt(this.report.reportType)) {
          this.$refs.lieReportDesign && this.$refs.lieReportDesign.drawLine()
        }
      })
      this.page.loading = false
    },

    getSummary () {
      let hasSummary = this.report.columns.some(m => m.summary)
      this.hasSummary = hasSummary
      if (hasSummary) {
        let params = this.param
        this.$axios.get(`/report-api/report/data/${this.report.id}/summary`, {params})
          .then(res => {
            this.summaryData = res.data
          })
      }
    },
    openDialog (view, title, width, targetId) {
      this.page.dialog = {
        visible: true,
        view,
        title,
        width,
        targetId
      }
      this.page.uploadResult.showButton = true
      this.$nextTick(() => this.$refs.safetyInput && this.$refs.safetyInput.focus())
    },
    openSeniorFilter () {
      if (this.report.advancedFilterColumns === null) {
        this.logicPanelData.table.columns = this.report.columns
      } else {
        this.logicPanelData.table.columns = []
        this.report.columns.forEach(m => {
          if (this.report.advancedFilterColumns.some(n => n === m.id)) {
            this.logicPanelData.table.columns.push(m)
          }
        })
      }
      this.logicPanelData.dialogType = 'runtime'
      // 打开高级属性面板
      this.logicPanelData.dialogVisible = true
    },
    expression (logicPanelData) {
      if (logicPanelData.expression !== '') {
        let filters = logicPanelData.filters
        let columns = logicPanelData.table.columns
        let expression = logicPanelData.expression
        logicPanelData.expression.match(/\$\{(.+?)\}/g).forEach(m => {
          let filterId = m.substring(2, m.length - 1)
          let filter = filters.find(filter => filter.id === filterId)
          let column = columns.find(column => column.id === filter.id)
          if (filter.defaultValue && filter.defaultValue2) {
            expression = expression.replace(m, '(' + column.expressionText + filter.condition + '"' + filter.defaultValue + '"' + filter.operation + column.expressionText + filter.condition2 + '"' + filter.defaultValue2 + '")')
          } else if (filter.defaultValue) {
            expression = expression.replace(m, column.expressionText + filter.condition + '"' + filter.defaultValue + '"')
          } else if (filter.defaultValue2) {
            expression = expression.replace(m, column.expressionText + filter.condition2 + '"' + filter.defaultValue2 + '"')
          } else if (filter.condition === 'isNull' || filter.condition === 'notNull') {
            expression = expression.replace(m, filter.condition + '(' + column.expressionText + ')')
          } else if (filter.condition2 === 'isNull' || filter.condition2 === 'notNull') {
            expression = expression.replace(m, filter.condition2 + '(' + column.expressionText + ')')
          }
        })
        this.param.filters = {}
        this.param.filters.seniorFilter = expression
      } else {
        this.param.filters = {}
        this.param.filters.seniorFilter = ''
      }
      this.search()
    },
    closeDialog (view) {
      this.page.dialog.visible = false
    },
    // 操作按钮
    handleCommand (object) {
      if (object && object.type === 'withoutImportButon') {
        this.doAction(object.button, object.dataId, object.reportId, object.name, this.currentRowData)
      } else if (object && object.type === 'template') {
        this.downDataTemplate(object.reportId, object.name)
      }
    },
    closeOrOpen (val) {
      if (this.$refs.tablePaganition) {
        this.$refs.tablePaganition.setHeight(val, this.$refs.filter)
      }
    },
    // 运行弹窗关闭事件
    closeRuntimeDialog () {
      // 导入过程中关闭弹窗，销毁定时器
      this.clearTimer = 3
      // 关闭弹窗时将倒入进度条置为0
      this.page.importFileProgress = 0
      if (['import-action', 'import'].includes(this.page.dialog.view)) {
        if (this.page.errorDataUrl) {
          this.page.errorDataUrl = ''
        }
        if (this.$refs.uploadButton instanceof Array) {
          this.$refs.uploadButton[0].clearFiles()
        } else {
          this.$refs.uploadButton.clearFiles()
        }
        this.page.fileStatus = ''
        this.page.fileProgress = 0
        this.page.fileDir = ''
      }
    },
    // 左侧树状模式和勾选模式值变化的时候需要搜索
    searchFilterWitchMoreType (data, filter) {
      let keys = Object.keys(data)
      for (let i = 0; i < keys.length; i++) {
        if (this.param && this.param.filters && typeof this.param.filters[keys[i]] === 'string') {
          this.param.filters[keys[i]] = data[keys[i]] ? data[keys[i]].join(', ') : ''
        }
      }
      // 只有当没有查询按钮的时候才会触发查询，否者都是修改筛选项的值
      // 或者当前筛选项开启了实时搜索
      if (this.report.filters.length === this.report.filters.filter(f => f.moreType).length || filter.immediate) {
        // 判断开启了勾选/树状模式的下拉框是否填写数据
        let requiredFilters = this.report.filters.filter(f => f.moreType && f.required)
        let noSelect = requiredFilters.filter(f => !this.param.filters[f.id])
        if (noSelect && noSelect.length) {
          return this.$message.error(`${noSelect.map(m => m.name).join(', ')}必填`)
        }
        // 这里搜索也需要触发原有的校验
        let canSearch = false
        if (this.$refs.filter && this.$refs.filter.$refs && this.$refs.filter.$refs.filterForm) {
          this.$refs.filter.$refs.filterForm.validate(v => {
            canSearch = v
          })
        }
        canSearch && this.$nextTick(() => {
          // 如果有其他的筛选项，则需要调用原来筛选项的 search方法
          if (this.report.filters.length !== this.report.filters.filter(f => f.moreType).length) {
            this.$refs.filter.search()
          } else {
            this.search()
          }
        })
      }
    },
    // 处理历史数据，因为control新增有其他属性，历史数据没有，所以重新实例化
    disposeHistoryData (data) {
      let disposeData = []
      data && data.length && data.forEach(d => disposeData.push(new Controls(d)))
      return disposeData
    },
    judgeChildren () {
      return this.getSpliceChildren.length && !this.hasChildren
    },
    // 多个禁用条件下禁用判定
    isDisabled (btn) {
      if (btn.conditions) {
        return !!btn.conditions.find(condition => condition.forbidden && !condition.tipsEnable)
      } else {
        return false
      }
    }
  },
  computed: {
    getSpliceChildren () {
      if (!this.report.children) {
        return []
      }
      return this.report.children.filter(m => m.type === 'splice')
    },
    getDialogChildren () {
      if (!this.report.children) {
        return []
      }
      return this.report.children.filter(m => m.type === 'dialog')
    },
    getImportButtons () {
      if (this.report.buttons) {
        return this.report.buttons.filter(m => m.type === 'import')
      }
    },
    getWithoutImportButtons () {
      if (this.getButtons) {
        return this.getButtons.filter(m => m.type !== 'import')
      }
    },
    getReportId () {
      return this.report.id
    },
    getButtons () {
      if (this.report.buttons) {
        let buttons = this.report.buttons.filter(m => ['create', 'export', 'custom-top', 'import', 'filter-item-calculation', 'import-action', 'logic'].some(n => n === m.type))
        return buttons
      } else {
        return []
      }
    },
    getOpenButtons () {
      let arr = this.getButtons.filter(n => n.showFlag === 'open')
      return arr
    },
    getFoldButtons () {
      let arr = this.getButtons.filter(n => n.showFlag === 'fold' || !n.showFlag)
      return arr
    },
    getButtonsLength () {
      //  有长度
      let buttons = this.getButtons
      let num = buttons.filter(n => n.showFlag === 'open').length
      if (num !== buttons.length) {
        //  小于总长。说明存在折叠情况。折叠的长度为1
        num++
      }
      return `${98 + (num - 1) * 95}px`
    },
    getFilterWidth () {
      return `calc(100% - ${this.getButtonsLength} )`
    },
    // 是否渲染筛选栏
    renderReportFilter () {
      if (this.referenceObjParam && this.referenceObjParam.type === 'rc-report') {
        // 如果是报表控件引用, 则不展示筛选项
        return false
      }
      return !!(this.getButtons.length > 0 || this.report.filters.filter(e => !e.hidden && e.filterType !== 'senior').length > 0)
    },
    getMoreTypeFilter () {
      return this.report.filters.filter(e => !e.hidden && e.filterType !== 'senior' && e.moreType)
    },
    getBackground () {
      if (this.report && this.report.background && this.report.background.src && parseInt(this.report.reportType) === 5) {
        return {
          'background-image': `url("${this.report.background.src.includes('/ak0000000386') ? sessionStorage.getItem('ossDownloadUrl') + this.report.background.src : `${require(`@/components/report/design/${this.report.background.absoluteSrc}`)}`}")`
        }
      } else return {}
    },
    noPagination ({referenceObjParam}) {
      if (this.page.count <= 500 && Number(this.report.pageNumber) === -999 && !(referenceObjParam && referenceObjParam.type)) {
        return true
      }
      return false
    }
  },
  mounted () {
    if (this.$refs.reportComponentList) {
      this.componentWidth = this.$refs.reportComponentList.$el.offsetWidth
    }
  }
}
</script>

<style lang="scss">
  @import "./assets/common";
  .runtime-dialog {
    .el-dialog {
      border-radius: 4px;
    }
    .el-dialog__header {
      height: 34px;
      line-height: 34px;
      padding: 0;
    }
    .el-dialog__body {
      padding: 25px 16px 30px;
      .runtime-dialog-file{
        text-align: center;
        .compareWord{
          margin-bottom: 35px;
          .el-icon-info{
            color: #C1C1C1;
            cursor: pointer;
            margin: 0 10px 0 5px;
            &:hover{
              color: #409EFF;
            }
          }
        }
        .runtime-dialog-file-title{
          margin-bottom: 30px;
          .el-button{
            position: relative;
            left: 48px;
            padding: 5px 10px;
          }
          .el-icon-info{
            color: #C1C1C1;
            cursor: pointer;
            position: relative;
            left: 58px;
            &:hover{
              color: var(--primary, #409EFF);
            }
          }
        }
        .runtime-dialog-file-upload{
          .el-icon-info{
            color: #C1C1C1;
            cursor: pointer;
            position: absolute;
            left: 318px;
            padding-top: 5px;
            &:hover{
              color: var(--primary, #409EFF);
            }
          }
        }
        .el-button{
           padding: 5px 10px;
          span{
            font-size: 12px;
          }
          &.cancal-button{
              width: 76px;
          }
        }
         p:not(.fileStatusName){
            height: 20px;
            line-height: 20px;
        }
        p {
          .el-icon-success{
            color:#67C23A;
          }
          span .el-icon-download{
            margin-left: 18px;
            cursor: pointer;
            color:var(--primary, #54ABF1);
            &:active{
              color:var(--shade-1, #3F91D3);
            }
          }
          &.fileStatusName {
            span {
              margin-bottom: 22px;
              display: block;
            }
          }
        }
        .runtime-dialog-file-name{
          span{
            padding-left: 17px;
          }
        }
        .runtime-dialog-file-status{
          visibility: hidden;
          margin: 10px 0;
          color: var(--primary, #54ABF1);
        }
        .runtime-dialog-file-status.file-status-visible{
          visibility: visible;
        }
        .runtime-dialog-file-status.file-status-color{
          color:#F9355A;
        }
        .runtime-dialog-file-rectangle{
          width:76px;
          height:70px;
          background:#EAF5FD;
          margin: 15px auto;
        }
        .runtime-dialog-file-rectangle.runtime-dialog-file-rectangle-fail{
          background:#EFF0F1 url('./assets/upload-fail.png') no-repeat center/cover;
        }
        .runtime-dialog-file-rectangle.runtime-dialog-file-rectangle-success{
          background:#EFF0F1 url('./assets/excel.png') no-repeat center/60%;
        }
        .el-progress{
          width: 76px;
          margin: 0 auto;
        }
        .import-file-progress {
          width: 250px;
          margin: 15px auto;
        }
      }
      .safety-password-dialog {
        text-align: center;
        padding: 0 24px;
        .el-form {
          margin-top: 25px;
          .el-input__inner {
            width: 190px;
            height: 28px;
            border: 1px solid #C2C3C4;
            border-radius: 4px;
          }
        }
      }
      .safety-password-dialog-footer {
        padding-top: 19px;
        text-align: center;
        .el-button {
          width:82px;
          height:26px;
          padding: 0;
          border: 1px solid var(--primary, #54ABF1);
          border-radius: 4px;
          color: var(--primary, #54ABF1);
          &:hover, &:active, &:focus {
            background-color: #fff;
            color: var(--primary, #54ABF1);
          }
        }
        .el-button--primary {
          color: #fff;
          background-color: var(--primary, #54ABF1);
          &:hover, &:active, &:focus {
            background-color: var(--primary, #54ABF1);
            color: #fff;
          }
        }
        .el-button + .el-button {
          margin-left: 50px;
          span{
            color: var(--primary, #54ABF1);
          }
        }
      }
    }
    .tip {
      text-align: center;
      color: red;
    }
    .center {
      margin-bottom:18px;
      text-align: center;
      &:nth-child(2) {
        margin-bottom: 20px;
      }
    }
    .red {
      color: #F95555;
    }
    .el-form--inline {
      display: flex;
      justify-content: center;
    }
  }
  #buttons{
    .open-button{
      margin-left: 10px;
      margin-bottom: 0;
      float: none;
      padding: 0 10px;
      span {
        font-size: 12px;
      }
    }
  }
  .row-right{
    height: 35px;
    line-height: 29px;
    & > .buttons {
      & > .first-button {
        padding-top: 0;
        margin-top: 3px;
        span {
          font-size: 12px;
        }
      }
    }
  }
  .filterMenu{
      width: 88px;
  }
  .report-component-custom-page {
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: center center;
    .custom-page-runtime-container {
      background-color: transparent;
      & > .custom-page-runtime-body {
        background-color: transparent;
        .control-body {
          background-color: #fff;
          .control {
            background-color: transparent;
          }
          .control-title {
            background-color: transparent;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/report/runtime/report-component.vue